import React from 'react'
import { object } from 'prop-types'

import { branch } from 'baobab-react/higher-order'
import config from 'config'

import BaseTemplate from 'components/templates/BaseTemplate'
import RelatedMajors from 'components/molecules/RelatedMajors'
import SimpleListSection from 'components/molecules/SimpleListSection'
import StickyBackLink from 'components/molecules/StickyBackLink'
import StickyBottomSchool from 'components/organisms/StickyBottomSchool'

import LayoutContext from 'utils/ui/LayoutContext'

import FacultySchoolIdentity from './FacultySchoolIdentity'
import FacultyDescription from './FacultyDescription'
import FacultyRegistrationStats from './FacultyRegistrationStats'
import FacultyStudyProgram from './FacultyStudyProgram'

const { assets_url: assetsUrl } = config
const Faculty = ({ faculty, school }) => {
  const {
    name,
    description,
    majors,
    careers,
    applicant_count: applicantCount,
    accepted_count: acceptedCount,
    admission_rate: admissionRate,
    admission_source: admissionSource,
    related_majors: {
      list,
    },
  } = faculty

  const facultyIdentity = {
    facultyName: name,
    schoolName: school.name,
    logo: school.logo,
  }

  return (
    <BaseTemplate
      stickyBottomContent={
        <StickyBottomSchool
          logo={school.logo}
          name={school.name}
          registrationUrl={school.registration_url}
          brochureUrl={school.brochure}
          likeStatus={school.liked}
          likeTarget={school.id}
          type="faculty"
        />
      }
      actionContent={{
        likeStatus: school.liked,
        likeTarget: school.id,
        kind: 'schools',
        type: 'faculty',
      }}
      useCTABottom={Boolean(school.registration_url || school.brochure)}
      useBackToTop
      useStickyBottom
      useNewHeader
    >
      <div className="faculty-school">
        <LayoutContext.Consumer>
          {
            navbar => (
              <StickyBackLink
                text="Kembali ke halaman kampus"
                url={`/directory/${school.slug}#faculties`}
                fixedNavbar={navbar.fixedNavbar}
                navbarHeight={navbar.navbarHeight}
              />
            )
          }
        </LayoutContext.Consumer>
        <FacultySchoolIdentity {...facultyIdentity} />
        { description && <FacultyDescription description={description} /> }
        {
          !!(applicantCount && acceptedCount) &&
          <FacultyRegistrationStats
            applicantCount={applicantCount}
            acceptedCount={acceptedCount}
            admissionRate={Math.round(admissionRate)}
            admissionSource={admissionSource}
          />
        }
        { (Object.keys(majors).length > 0) && <FacultyStudyProgram majors={majors} /> }
        { (Object.keys(list).length > 0) && <RelatedMajors list={list} /> }
        {
          (careers.length > 0) &&
          <SimpleListSection
            list={careers}
            title="Karier"
            backgroundUrl={`${assetsUrl}/assets/img/career_bg/career-woman-bw.jpg`}
            marginTop={120}
          />
        }
      </div>
      <style jsx>
        {`
          .faculty-school {
            background-color: #fff;
            color: #0c2846;
          }
        `}
      </style>
    </BaseTemplate>
  )
}

Faculty.propTypes = {
  faculty: object,
  school: object,
}

export { Faculty }

export default branch({
  faculty: ['serverProps', 'faculty'],
  school: ['serverProps', 'school'],
}, Faculty)
